import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
export default store => {
  return {
    path: "staff",
    component: withAsyncRouteLoading(() => {
      return Promise.all([
        import(/* webpackChunkName: "staff" */ "./components"),
        import(/* webpackChunkName: "staff" */ "./modules/Module"),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "toddleStaffWizard",
          reducer,
        });
        return component;
      });
      //.catch(err => {
      // throw err;
      // });
    }),
  };
};
